import { render, staticRenderFns } from "./Nomenclature.vue?vue&type=template&id=3c66fed2&scoped=true&"
import script from "./Nomenclature.vue?vue&type=script&lang=js&"
export * from "./Nomenclature.vue?vue&type=script&lang=js&"
import style0 from "./Nomenclature.vue?vue&type=style&index=0&id=3c66fed2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c66fed2",
  null
  
)

export default component.exports